(function () {
  // ícones inline (SVG)
  const playSvg =
    '<svg viewBox="0 0 20 20"><polygon points="3,2 17,10 3,18"></polygon></svg>';
  const pauseSvg =
    '<svg viewBox="0 0 20 20"><rect x="3" y="2" width="5" height="16"></rect><rect x="12" y="2" width="5" height="16"></rect></svg>';

  function show(ctrl, html) {
    ctrl.innerHTML = html;
    ctrl.hidden = false;
  }
  function spin(ctrl, on) {
    ctrl.innerHTML = on ? '<span class="pc-video-spin"></span>' : playSvg;
    ctrl.hidden = false;
  }

  /* ---------- HTML5 VIDEO (mapeamento invertido) ---------- */
  function bindNativeVideo(video, ctrl) {
    const tryPlay = () => video.play && video.play().catch(() => {});
    // INVERTIDO: se está tocando, mostra PLAY; se pausado, mostra PAUSE
    video.addEventListener("playing", () => show(ctrl, playSvg));
    video.addEventListener("pause", () => show(ctrl, pauseSvg));
    video.addEventListener("waiting", () => spin(ctrl, true));
    video.addEventListener("canplay", () => show(ctrl, playSvg));
    ctrl.addEventListener("click", () => (video.paused ? tryPlay() : video.pause()));
    // fallback: se autoplay falhar, ainda assim mostre PLAY primeiro
    setTimeout(() => show(ctrl, playSvg), 500);
  }

  /* ---------- YOUTUBE / VIMEO (mapeamento invertido) ---------- */
  function bindIframe(iframe, ctrl) {
    const host = (iframe.dataset.host || "").toLowerCase();
    const YT_STATES = { "-1": "unstarted", 0: "ended", 1: "playing", 2: "paused", 3: "buffering", 5: "cued" };

    const post = (obj) =>
      iframe.contentWindow && iframe.contentWindow.postMessage(obj, "*");

    const play = () => {
      if (host === "youtube")
        post(JSON.stringify({ event: "command", func: "playVideo", args: [] }));
      else post({ method: "play" });
    };
    const pause = () => {
      if (host === "youtube")
        post(JSON.stringify({ event: "command", func: "pauseVideo", args: [] }));
      else post({ method: "pause" });
    };
    const seek0 = () => {
      if (host === "youtube")
        post(JSON.stringify({ event: "command", func: "seekTo", args: [0, true] }));
      else post({ method: "setCurrentTime", value: 0 });
    };

    // Clique: mantém a ação normal (se está tocando, pausa; se está pausado, volta do zero e toca)
    ctrl.addEventListener("click", () => {
      if (ctrl.dataset.state === "playing") pause();
      else { seek0(); play(); }
    });

    // Listener de estado (INVERTIDO no ícone)
    window.addEventListener("message", (e) => {
      if (e.source !== iframe.contentWindow) return;
      try {
        const data = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
        if (host === "youtube" && data.event === "onStateChange") {
          const st = YT_STATES[data.info];
          if (st === "playing") { ctrl.dataset.state = "playing"; show(ctrl, playSvg); }
          else if (st === "paused") { ctrl.dataset.state = "paused"; show(ctrl, pauseSvg); }
          else if (st === "buffering") spin(ctrl, true);
        } else if (host === "vimeo" && data.event) {
          if (data.event === "play")  { ctrl.dataset.state = "playing"; show(ctrl, playSvg); }
          if (data.event === "pause") { ctrl.dataset.state = "paused"; show(ctrl, pauseSvg); }
          if (data.event === "bufferstart") spin(ctrl, true);
        }
      } catch (_) {}
    });

    // Mostrar spinner inicialmente; depois, se nada chegou ainda, mostra PLAY primeiro
    spin(ctrl, true);
    setTimeout(() => show(ctrl, playSvg), 1200);
  }

  /* ---------- BIND TODOS OS VÍDEOS ---------- */
  function init() {
    document.querySelectorAll(".pc-video-wrapper").forEach((wrap) => {
      const videoEl = wrap.querySelector(".pc-video-el");
      const ctrl = wrap.querySelector(".pc-video-ctrl");
      if (!videoEl || !ctrl || ctrl.dataset.pcBound) return;
      ctrl.dataset.pcBound = "1";

      if (videoEl.tagName === "VIDEO") bindNativeVideo(videoEl, ctrl);
      else bindIframe(videoEl, ctrl); // iframe YT/Vimeo
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();
